var isScrolling;

const clearActivs = () => {
    var container = window.document.getElementById("navmenu").querySelector(".container");
    for (var j = 0, i = 0; i < container.childElementCount; i++) {
        if (container.children[i].className.indexOf("circle") == -1) continue;

        container.children[i].className = container.children[i].className.replace(" active", "");
    }
}
const setScrollNaming = section => {
    var className = section.className.split(" ")[1].split("-")[1];
    window.addEventListener("scroll", () => {
        if (window.scrollY >= section.offsetTop - 0.10 * section.offsetTop &&
            window.scrollY < section.offsetTop + section.clientHeight) {
            window.clearTimeout(isScrolling);
            isScrolling = setTimeout(() => {
                window.history.pushState(null, `/`, `?s=${className}#`);
                clearActivs();
                window.document.querySelector(`.circle.${className}`).className += " active";
            }, 66);
        }
    })
}

export {
    setScrollNaming
}


// WEBPACK FOOTER //
// ./src/Components/Services/ScrollURL.js